import { COMPONENT_FACTORY_CONFIG_INPUT_COMPONENTS } from '@core/components/component-factory/component-factory-config-input.registry';
import type { ConfigComponentContract } from '@shared/utils/content-builder/config-component-contract';
import { computedResolvedConfig } from '@shared/utils/content-builder/block-config-computed-resolver';
import type { ComoPunchCardsBlockConfig } from '@front-platform/content-builder';
import { comoPunchCardsBlockResolveConfig } from '@front-platform/content-builder';
import { takeUntil, tap } from 'rxjs/operators';
import { Component, OnInit, inject, input } from '@angular/core';
import type { ComoPunchCardsBlockScenarioContent } from '@front-platform/content-builder';
import { COMO_PUNCH_CARDS_BLOCK_COMPONENT } from '@core/services/cb2-preview/cb2-preview-bloc-types';
import { Cb2PreviewStateService } from '@core/services/cb2-preview/cb2-preview-state.service';
import { previewScenarioData } from '@core/services/cb2-preview/preview-scenario-data.util';
import { previewScenarioForBloc$ } from '@core/services/cb2-preview/preview-scenario-for-bloc.util';

import { ComoUser } from '@core/models/como.model';
import { ComoService } from '@core/services/como/como.service';
import { DestroyerBase } from '@core/base/destroyer/destroyer.base';
export interface ComoPunchCardsBlockRuntimeConfig {}

export type ComoPunchCardsBlockConfigInput = Partial<
  Omit<ComoPunchCardsBlockConfig, keyof ComoPunchCardsBlockRuntimeConfig> &
    ComoPunchCardsBlockRuntimeConfig
>;
export type ComoPunchCardsBlockResolvedConfig = Omit<
  ComoPunchCardsBlockConfig,
  keyof ComoPunchCardsBlockRuntimeConfig
> &
  Partial<ComoPunchCardsBlockRuntimeConfig>;
export interface ComoPunchCardsBlockContract extends ConfigComponentContract<
  ComoPunchCardsBlockConfigInput,
  ComoPunchCardsBlockResolvedConfig
> {}

@Component({
  selector: 'app-como-punch-cards-block',
  templateUrl: './como-punch-cards-block.component.html',
  styleUrls: ['./como-punch-cards-block.component.scss'],
  standalone: false,
})
export class ComoPunchCardsBlockComponent
  extends DestroyerBase
  implements OnInit, ComoPunchCardsBlockContract
{
  readonly config = input<ComoPunchCardsBlockConfigInput>({});
  readonly resolvedConfig = computedResolvedConfig<
    ComoPunchCardsBlockConfig,
    ComoPunchCardsBlockRuntimeConfig
  >(comoPunchCardsBlockResolveConfig, () => ({ config: this.config() }));
  public comoUser?: ComoUser | null;

  private readonly cb2PreviewState = inject(Cb2PreviewStateService);
  private readonly previewScenario$ = previewScenarioForBloc$(
    COMO_PUNCH_CARDS_BLOCK_COMPONENT,
  );

  constructor(private readonly comoService: ComoService) {
    super();
  }

  ngOnInit(): void {
    if (this.cb2PreviewState.isActive()) {
      this.previewScenario$
        .pipe(
          takeUntil(this._destroyerRef),
          tap(scenario => {
            const content = previewScenarioData<ComoPunchCardsBlockScenarioContent>(
              scenario,
              COMO_PUNCH_CARDS_BLOCK_COMPONENT,
            );
            this.comoUser = (content?.comoUser as ComoUser | null | undefined) ?? null;
          }),
        )
        .subscribe();
      return;
    }

    this.comoService.loadComoUser();
    this.comoService
      .getComoUser$()
      .pipe(
        takeUntil(this._destroyerRef),
        tap(comoUser => (this.comoUser = comoUser)),
      )
      .subscribe();
  }
}
COMPONENT_FACTORY_CONFIG_INPUT_COMPONENTS.set(ComoPunchCardsBlockComponent, { 'keyAliases': {} });
